import styled from '@emotion/styled'

export const ContentContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  //gap: spacing.smx1,
  flex: 1,
})
